export default __webpack_public_path__ + "static/media/menu_link_account_not_selected.47429a66.svg";